import React from 'react';
import { Modal, Card, Tag, Space, Typography, List, Spin, Empty } from 'antd';
import { ThunderboltOutlined, BulbOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

interface LifetreeSuggestion {
  title: string;
  description: string;
  tags: string[];
  reason: string;
}

interface LifetreeSuggestionsModalProps {
  visible: boolean;
  onCancel: () => void;
  suggestions: LifetreeSuggestion[];
  loading: boolean;
  onSelectSuggestion: (suggestion: LifetreeSuggestion) => void;
}

const LifetreeSuggestionsModal: React.FC<LifetreeSuggestionsModalProps> = ({
  visible,
  onCancel,
  suggestions,
  loading,
  onSelectSuggestion
}) => {
  return (
    <Modal
      title={
        <Space>
          <BulbOutlined style={{ color: '#faad14' }} />
          <span>Gợi ý ý tưởng LifeTree mới (AI)</span>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
      bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Spin size="large" tip="AI đang phân tích và đề xuất ý tưởng..." />
        </div>
      ) : suggestions.length > 0 ? (
        <List
          grid={{ gutter: 16, column: 1 }}
          dataSource={suggestions}
          renderItem={(item) => (
            <List.Item>
              <Card
                hoverable
                className="suggestion-card"
                onClick={() => onSelectSuggestion(item)}
                style={{ border: '1px solid #f0f0f0', borderRadius: '8px' }}
                title={
                  <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                    <Text strong style={{ fontSize: '16px' }}>{item.title}</Text>
                    <CheckCircleOutlined className="select-icon" style={{ color: '#1890ff', fontSize: '20px', display: 'none' }} />
                  </Space>
                }
              >
                <div style={{ marginBottom: 12 }}>
                  {item.tags.map(tag => (
                    <Tag key={tag} color="blue" style={{ marginBottom: 4 }}>{tag}</Tag>
                  ))}
                </div>
                
                <Paragraph type="secondary" style={{ marginBottom: 16 }}>
                  {item.description}
                </Paragraph>
                
                <div style={{ padding: '12px', background: '#fff7e6', borderRadius: '4px', borderLeft: '4px solid #ffa940' }}>
                  <Text strong style={{ color: '#d46b08', display: 'block', marginBottom: 4, fontSize: '12px' }}>
                    <ThunderboltOutlined /> Tại sao nên chọn ý tưởng này?
                  </Text>
                  <Text style={{ color: '#874d00', fontSize: '12px' }}>
                    {item.reason}
                  </Text>
                </div>
              </Card>
            </List.Item>
          )}
        />
      ) : (
        <Empty description="Không có gợi ý nào được tạo ra." />
      )}
      
      <style>{`
        .suggestion-card:hover {
          border-color: #1890ff !important;
          box-shadow: 0 4px 12px rgba(24, 144, 255, 0.1);
        }
        .suggestion-card:hover .select-icon {
          display: block !important;
        }
      `}</style>
    </Modal>
  );
};

export default LifetreeSuggestionsModal;
